<template>
<div class="chapter">
<div class="inner_page">
<h1 class="sigil_not_in_toc" id="id00008">THE TALLEYRAND MAXIM</h1>
<h4 class="sigil_not_in_toc1" id="id00009">BY J. S. FLETCHER</h4>
<p class="calibre1" id="id00010">1920</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?464a0746